import React, {Suspense} from 'react';
import {Grid, Stack} from "@mui/material";
import {drawCircle, drawLine, mapMotorToCanvas} from "../utils/map_utils";
import {getPrefixedUrl} from "../../../utils/utils";

const Plot = React.lazy(() => import("react-plotly.js"));

const handlePlotTS = (takeStep) => {
    return {
        x: takeStep['X'],
        y: takeStep['Y'],
        type: "scatter",
        mode: "markers",
        marker: {color: "red"},
        name: takeStep['Name']
    }
}

const handlePlotFL = (fineLocator) => {
    return {
        x: fineLocator['X'],
        y: fineLocator['Y'],
        type: "scatter",
        mode: "markers",
        marker: {color: "blue"},
        name: fineLocator['Name']
    }
}


export const getPlotPopup = (zProfilePath, finalPlotData, index) => {
    const layout = {
        title: `${zProfilePath} :: ID-${index}`,
    };
    return (
        <Grid>
            <Suspense fallback={<div>Loading...</div>}>
                <Plot data={finalPlotData}
                    layout={layout}/>
            </Suspense>
        </Grid>
    );
}

export const getFinalPlotData = (focusPlot) => {
    let finalPlotData = [];
    Object.values(focusPlot['takeStep']).forEach(value => {
        Object.values(value).forEach(plotData => {
            Object.values(plotData).forEach(vals => {
                finalPlotData = finalPlotData.concat(handlePlotTS(vals));
            })
        })
    });
    Object.values(focusPlot['fineLocator']).forEach(plotData => {
        finalPlotData = finalPlotData.concat(handlePlotFL(plotData));
    });
    return finalPlotData;
}

export const plotDicyStreak = (tileFlag, val, slide, vectorSource, deviceSettings, y_fields, tile_height, uperpixel, textColor, textSize, folderLink) => {
    let xPosition = parseInt(val["motorPosX"]);
    let yPosition = parseInt(val["motorPosY"]);
    let {x, y} = mapMotorToCanvas(xPosition, yPosition, slide,
        {device_settings: deviceSettings});
    x = x + 150;
    if (tileFlag['reverseYTileOrder']['flagY'])
        y = y_fields * tile_height * uperpixel - y + 130;
    else
        y = y + 130;
    drawLine(x, y, 1, vectorSource, val["index"], 10,
        "#E9D6C5", "", textColor, textSize);
    drawLine(x, y + 30, 1, vectorSource, "T% " + parseFloat(val["tissuePercent"]).toFixed(2), 10,
        "#E9D6C5", "", textColor, textSize);
    let link1 = getPrefixedUrl(`debug/zprofile/${val["tissueImgPath"]}`, slide, true);
    let link2 = getPrefixedUrl(`debug/zprofile/${val["nonTissueImgPath"]}`, slide, true);
    let popupText = (
        <Stack>
            <Grid>
                {"Tissue % : " + parseFloat(val["tissuePercent"]).toFixed(2)}
                <a href={folderLink}>{" [Folder] "}</a>
            </Grid>
            <Grid>
                <a href={link1} target={"_blank"}>{"[Tissue Img] "}</a>
                <a href={link2} target={"_blank"}>{" [Thresholded Img]"}</a>
            </Grid>
        </Stack>
    );
    drawCircle(x, y, 25, vectorSource, "",
        6, "#ff8c00", popupText, textColor);
}